<script lang="ts">
	import H from '#lib/html/h/H.svelte';

	interface Props {
		level?: string;
		className?: string;
		children?: import('svelte').Snippet;
	}

	let { level = '1', className = 'mt-4 mb-8', children }: Props = $props();
</script>

<H {level} className="{className} text-balance" fontClasses="font-extralight">
	{@render children?.()}
</H>
